import { render } from "./PantryDetailPage.vue?vue&type=template&id=954e8ca4&ts=true"
import script from "./PantryDetailPage.vue?vue&type=script&lang=ts"
export * from "./PantryDetailPage.vue?vue&type=script&lang=ts"

import "./PantryDetailPage.vue?vue&type=style&index=0&id=954e8ca4&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__